import React from "react";
import ReactGA from "react-ga";
import { withRouter } from "react-router";

// eslint-disable-next-line no-undef
ReactGA.initialize(`${process.env.REACT_APP_GA_KEY}` || "UA-FAKE-ID");

class GAListener extends React.Component {
  componentDidMount() {
    const page = this.props.location.pathname + this.props.location.search;
    this.sendPageView(page);
  }

  componentDidUpdate(oldProps) {
    const oldPage = oldProps.location.pathname + oldProps.location.search;
    const newPage = this.props.location.pathname + this.props.location.search;

    if (oldPage !== newPage) {
      this.sendPageView(newPage);
    }
  }

  sendPageView(page) {
    ReactGA.set({ page: page });
    ReactGA.pageview(page);
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(GAListener);
